// extracted by mini-css-extract-plugin
module.exports = {"content":"Launch_content__ttmPf","heading":"Launch_heading__jH8GI","downloadText":"Launch_downloadText__aykvh","launch":"Launch_launch__MDijx","buttons":"Launch_buttons__6eM6a"};